import { KuxFilteredCategoriesDTO } from '@kaltura-ott/tvpil';
import { useMemo } from 'react';

import { useCollectionMeta } from '../collection/useCollectionMeta';

import type { ImageSize } from './useImageSettings';

type UseCollectionGridSettingsProps = {
  gridReferenceId: string;
  railReferenceId: string;
  imageSize?: ImageSize;
};

export type CollectionGridSettings = {
  branding: KuxFilteredCategoriesDTO['uiDesignElements'];
  imageHeight?: number;
  imageType?: number;
  imageWidth?: number;
  isGrouped: boolean;
  parentalPinProtected: boolean;
  shouldShowEntitlementIndicator: boolean;
  shouldShowRating: boolean;
  providerName: string;
  title: string | undefined;
};

export function useCollectionGridSettings({
  imageSize = 'default',
  gridReferenceId,
  railReferenceId,
}: UseCollectionGridSettingsProps) {
  const { isLoading, data, error } = useCollectionMeta({ imageSize, gridReferenceId, railReferenceId });

  const settings = useMemo<CollectionGridSettings | undefined>(() => {
    if (isLoading || !data) {
      return undefined;
    }

    return {
      branding: data.branding,
      imageHeight: data.imageHeight,
      imageRatio: data.imageRatio,
      imageType: data.imageType,
      imageWidth: data.imageWidth,
      isGrouped: data.isGrouped,
      parentalPinProtected: data.parentalPinProtected,
      shouldShowEntitlementIndicator: data.shouldShowEntitlementIndicator,
      shouldShowRating: data.shouldShowRating,
      providerName: data.providerName,
      title: data.title,
    };
  }, [data, isLoading]);

  return {
    settings,
    error,
    isLoading,
  };
}
